import React from 'react';

const Seceder = () => {
    return <div>Seceder</div>;
};

export default Seceder;
